import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class AcceptedLanguageInterceptor implements HttpInterceptor{
    constructor(protected translate: TranslateService) {
    }
  
    intercept(req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {

        if(this.translate.currentLang){
            let languageRequest = req.clone({ setHeaders: { 'Accept-Language': this.translate.currentLang } });
            return next.handle(languageRequest);
        }
        else if (this.translate.defaultLang){
            let languageRequest = req.clone({ setHeaders: { 'Accept-Language': this.translate.defaultLang } });
            return next.handle(languageRequest);
        }
        else {
            return next.handle(req);
        }

    }
}
